import * as Sentry from '@sentry/react';

// Debug utility to test if Sentry is working
export function testSentryConnection() {
  console.log('Testing Sentry connection...');
  
  // Test 1: Add a breadcrumb
  Sentry.addBreadcrumb({
    message: 'Sentry test breadcrumb',
    category: 'debug',
    level: 'info',
    data: { timestamp: new Date().toISOString() }
  });
  
  // Test 2: Capture a test message
  Sentry.captureMessage('Sentry test message from bilingual-exam-registry', 'info');
  
  // Test 3: Capture a test exception
  try {
    throw new Error('Sentry test error - this is intentional');
  } catch (error) {
    Sentry.captureException(error, {
      tags: {
        test: true,
        component: 'debug'
      },
      extra: {
        message: 'This is a test error to verify Sentry integration',
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent
      }
    });
  }
  
  console.log('Sentry test completed - check your Sentry dashboard');
}

// Add this to window object for easy testing in browser console
if (globalThis.window !== undefined) {
  (globalThis as any).testSentry = testSentryConnection;
}